export default __webpack_public_path__ + "static/media/troubleshoot.aeeed075.svg";